import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link, useLoaderData } from "react-router-dom";
import ApiService from "../../helper/api";
import AlertService from "../../helper/alertService";
import Urls from "./url/Urls";
import NetworkForm from "./NetworkForm";
import Header from "../../componets/Header";
import { FaCircleArrowLeft } from "react-icons/fa6";
import { FaEye, FaEyeSlash, FaCopy } from "react-icons/fa";

function Componet(props) {
	const { network, urlTypes, urlNames } = useLoaderData();
	const [isDisabledFields, setIsDisabledFields] = useState(false);
	const [showApiKey, setShowApiKey] = useState(false);
	const [copied, setCopied] = useState(false);

	const [_network, _setNetwork] = useState(false);
	const getNetworkPlatformByid = networkId => {
		if (!networkId) {
			return false;
		}
		setIsDisabledFields(true);
		ApiService.getNetworkPlatformByid(networkId)
			.then(response => {
				if (response && response.data) {
					_setNetwork(response.data);
				}
			})
			.catch(error => AlertService.alert("error", error))
			.finally(() => {
				setIsDisabledFields(false);
			});
	};

	const closeModal = () => {
		_setNetwork(null);
	};

	const handleCopy = async value => {
		try {
			await navigator.clipboard.writeText(value);
			setCopied(true);
			setTimeout(() => setCopied(false), 1500);
		} catch (e) {
			console.error("Copy failed");
		}
	};

	return (
		<div className="py-3">
			<Header>
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex gap-2 align-items-center">
						<Link to="/network-platforms">
							<FaCircleArrowLeft size={20} />
						</Link>
						<h4 className="mb-0 ">{network?.name} Platform</h4>
					</div>
					<Button
						variant="primary"
						size="sm"
						className="px-4"
						disabled={isDisabledFields}
						onClick={() => {
							getNetworkPlatformByid(network.id);
						}}>
						Edit
					</Button>
				</div>
			</Header>
			<Container>
				{/* ===== HEADER ===== */}
				{/* <div className="mb-4">
					<div className="d-flex justify-content-between align-items-center bg-white p-3 rounded shadow-sm">
						<div className="d-flex gap-2 align-items-center">
							<Link to="/network-platforms" className="text-dark">
								<FaCircleArrowLeft size={22} />
							</Link>
							<h4 className="mb-0 fw-semibold">
								{network?.name || "Network"} Platform
							</h4>
						</div>

						<Button
							variant="outline-primary"
							size="sm"
							className="px-4"
							disabled={isDisabledFields}
							onClick={() => getNetworkPlatformByid(network.id)}>
							Edit
						</Button>
					</div>
				</div> */}

				{/* ===== CONTENT ===== */}
				{network ? (
					<Row className="gy-4">
						{/* ===== INFO CARD ===== */}
						<Col md={12}>
							<div className="bg-white rounded shadow-sm p-4">
								{/* Name */}
								<div className="mb-3">
									<strong>Name:</strong>{" "}
									<span className="text-success fw-semibold ms-2">
										{network.name}
									</span>
								</div>

								{/* Status */}
								<div className="mb-2">
									<strong>Status:</strong>{" "}
									<span
										className={
											network.isActive ? "badge bg-success" : "badge bg-danger"
										}>
										{network.isActive ? "Active" : "Inactive"}
									</span>
								</div>

								{/* Network Type */}
								<div className="mb-2">
									<strong>Network Type:</strong>{" "}
									<span className="badge bg-secondary">
										{network.networkType || "Unknown"}
									</span>
								</div>

								<hr />

								{/* API KEY */}
								{network.apiKey && (
									<div className="mb-2">
										<strong>Api key</strong>
										<div className="d-flex align-items-center border rounded px-3 py-2">
											<span
												className="flex-grow-1 max-line-1"
												title={network.apiKey}>
												{showApiKey ? network.apiKey : "•".repeat(20)}
											</span>

											<div className="d-flex gap-3 ms-3">
												<span
													role="button"
													title={showApiKey ? "Hide" : "Show"}
													className="text-secondary"
													onClick={() => setShowApiKey(prev => !prev)}>
													{showApiKey ? <FaEyeSlash /> : <FaEye />}
												</span>

												<span
													role="button"
													title="Copy"
													className="text-secondary"
													onClick={() => handleCopy(network.apiKey)}>
													<FaCopy />
												</span>
											</div>
										</div>
										{copied && (
											<div className="text-success small mt-1">Copied ✔</div>
										)}
									</div>
								)}

								{/* LINKS */}
								<div className="mb-2">
									<strong>Web Address:</strong>{" "}
									{network.webAddress ? (
										<a
											href={network.webAddress}
											target="_blank"
											rel="noopener noreferrer"
											className="text-decoration-none max-line-1 d-inline-block"
											title={network.webAddress}>
											{network.webAddress}
										</a>
									) : (
										<span className="text-danger ms-2">...</span>
									)}
								</div>

								<div className="mb-2">
									<strong>Documentation:</strong>{" "}
									{network.docsAddress ? (
										<a
											href={network.docsAddress}
											target="_blank"
											rel="noopener noreferrer"
											className="text-decoration-none max-line-1 d-inline-block"
											title={network.docsAddress}>
											{network.docsAddress}
										</a>
									) : (
										<span className="text-danger ms-2">...</span>
									)}
								</div>

								<div className="mb-2">
									<strong>URL Address:</strong>{" "}
									{network.urlAddress ? (
										<a
											href={network.urlAddress}
											target="_blank"
											rel="noopener noreferrer"
											className="text-decoration-none max-line-1 d-inline-block"
											title={network.urlAddress}>
											{network.urlAddress}
										</a>
									) : (
										<span className="text-danger ms-2">...</span>
									)}
								</div>

								<div className="mb-2">
									<strong>Data Address:</strong>{" "}
									{network.dataAddress ? (
										<a
											href={network.dataAddress}
											target="_blank"
											rel="noopener noreferrer"
											className="text-decoration-none max-line-1 d-inline-block"
											title={network.dataAddress}>
											{network.dataAddress}
										</a>
									) : (
										<span className="text-danger ms-2">...</span>
									)}
								</div>
							</div>
						</Col>
					</Row>
				) : (
					<div className="text-center py-5">
						<h5 className="text-muted">No Data</h5>
					</div>
				)}
				<Row className="mt-4">
					<Col sm={12}>
						<div className="bg-white rounded shadow-sm p-4">
							<Urls
								_urls={network?.urls}
								urlTypes={urlTypes}
								urlNames={urlNames}
							/>
						</div>
					</Col>
				</Row>

				<NetworkForm closeModal={closeModal} network={_network} />
			</Container>
		</div>
	);
}

const loader = async ({ request, params: { networkId } }) => {
	try {
		const network = await ApiService.getNetworkPlatformByid(networkId)
			.then(response => {
				if (response.data) {
					return response.data;
				} else {
					return null;
				}
			})
			.catch(error => {
				AlertService.alert("error", error);
			});
		const urlTypes = await ApiService.getUrlTypes()
			.then(response => {
				if (response.data) {
					return response.data;
				} else {
					return null;
				}
			})
			.catch(error => {
				AlertService.alert("error", error);
			});
		const urlNames = await ApiService.getUrlNames()
			.then(response => {
				if (response.data) {
					return response.data;
				} else {
					return null;
				}
			})
			.catch(error => {
				AlertService.alert("error", error);
			});
		return { network, urlTypes, urlNames };
	} catch (error) {
		AlertService.alert("error", error);
		return error;
	}
};
const NetworkView = Object.assign(Componet, { loader });
export default NetworkView;
